'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["notifications", "onRemoveNotification"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { filterProps } from 'foundations-components/utils/filterProps';
import { removeNotification } from '../actions/NotificationActions';
import { jsx as _jsx } from "react/jsx-runtime";
class NotificationList extends Component {
  render() {
    const _this$props = this.props,
      {
        notifications,
        onRemoveNotification
      } = _this$props,
      restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      domProps,
      tokenProps
    } = filterProps(restProps);
    const floatingAlerts = Object.keys(notifications).map(notificationId => {
      const clonedNotification = Object.assign({}, notifications[notificationId]);
      // These properties are only used internally by ReduxMessenger,
      // and should not be passed onto the FloatingAlert component
      delete clonedNotification.sticky;
      delete clonedNotification.timeout;
      return clonedNotification;
    });
    return /*#__PURE__*/_jsx(FloatingAlertList, Object.assign({}, tokenProps, domProps, {
      alerts: floatingAlerts,
      onAlertClose: (evt, {
        id
      }) => onRemoveNotification(id)
    }));
  }
}
NotificationList.propTypes = {
  'data-test-id': PropTypes.string,
  notifications: PropTypes.object.isRequired,
  onRemoveNotification: PropTypes.func.isRequired
  // the component can also make use of Trellis tokenProps
};
const mapStateToProps = state => ({
  notifications: state.notifications
});
const actionCreators = {
  onRemoveNotification: removeNotification
};
export default connect(mapStateToProps, actionCreators)(NotificationList);